import { map } from 'es-toolkit/compat';

import { DateTimeException, LocalDate } from 'js-joda';
import { Grid } from 'ui';
import { core } from '@tock/coretypes';
import { logger } from '@tock/logging';
import ImportantDate from './ImportantDate';
import Subheader from 'components/profile/Subheader';

interface OwnProps {
  importantDates: core.IPatronProfileDay[];
}

const DUMMY_YEAR = 2000; // We only need a date for formatting, not actually used

const ProfileImportantDates = ({ importantDates }: OwnProps) => {
  return (
    <>
      <Subheader text="Important Dates" />
      <Grid container spacing={2}>
        {map(importantDates, (date) => {
          if (date.month && date.day && date.type) {
            try {
              return (
                <Grid
                  key={`${date.type}-${date.month}-${date.day}-${date.year}`}
                  item
                  xs={12}
                  sm={6}
                  lg={3}
                >
                  <ImportantDate
                    date={LocalDate.of(DUMMY_YEAR, date.month, date.day)}
                    type={date.type}
                  />
                </Grid>
              );
            } catch (e) {
              if (e instanceof DateTimeException) {
                logger.error('error parsing date', e);
                return null;
              } else {
                throw e;
              }
            }
          }
          return null;
        })}
      </Grid>
    </>
  );
};

export default ProfileImportantDates;
